import React from "react";
import { useNavigate } from "react-router-dom";
import HeroAnimatedTitle from "./HeroAnimatedTitle";
import "./HeroContent.css";

const HeroContent = () => {
  const navigate = useNavigate();

  return (
    <div className="hero-content">
      <HeroAnimatedTitle />
      
      <div className="hero-buttons">
        <button
          className="hero-btn-primary"
          onClick={() => navigate("/contact-us")}
        >
          Build With AMPLE House
          <span className="hero-btn-arrow">→</span>
        </button>

        <button
          className="hero-btn-secondary"
          onClick={() => navigate("/about-us")}
        >
          Explore AMPLE House
        </button>
      </div>
    </div>
  );
};

export default HeroContent;